import { Message, DomainMessagesTypes } from '../message';

export function isDocumentationDeleted(message: Message): boolean {
  return message.type === DomainMessagesTypes.documentationDeleted;
}

export function isDocumentationRestored(message: Message): boolean {
  return message.type === DomainMessagesTypes.documentationRestored;
}
